export interface AddressFieldConfig {
    key: string;
    label: string;
    widthClass: string;
    optional?: boolean;
    labelWidthClass?: string;
}

export const addressConfig: Record<string, AddressFieldConfig[]> = {
    US: [
        { key: 'line1', label: 'Address Line 1', widthClass: 'w-[295px] md:w-[600px] xl:w-[573px]', labelWidthClass: 'w-[98px]' },
        { key: 'line2', label: 'Address Line 2', widthClass: 'w-[295px] md:w-[600px] xl:w-[573px]', optional: true },
        { key: 'city', label: 'City', widthClass: 'w-[141.5px] md:w-[314px] xl:w-[280.5px]', labelWidthClass: 'w-[26px]' },
        { key: 'state', label: 'State of Residence', widthClass: 'w-[141.5px] md:w-[314px] xl:w-[280.5px]', labelWidthClass: 'w-[124px]' },
        { key: 'zip', label: 'Postal Code', widthClass: 'w-[141.5px] md:w-[314px] xl:w-[280.5px]', labelWidthClass: 'w-[79px]' }
    ],
    CA: [
        { key: 'line1', label: 'Address Line 1', widthClass: 'w-[295px] md:w-[600px] xl:w-[573px]', labelWidthClass: 'w-[98px]' },
        { key: 'line2', label: 'Address Line 2', widthClass: 'w-[295px] md:w-[600px] xl:w-[573px]', optional: true },
        { key: 'city', label: 'City', widthClass: 'w-[141.5px] md:w-[314px] xl:w-[280.5px]', labelWidthClass: 'w-[26px]' },
        { key: 'state', label: 'Province', widthClass: 'w-[141.5px] md:w-[314px] xl:w-[280.5px]', labelWidthClass: 'w-[124px]' },
        { key: 'postcode', label: 'Postal Code', widthClass: 'w-[141.5px] md:w-[314px] xl:w-[280.5px]', labelWidthClass: 'w-[79px]' }
    ],
    DEFAULT: [
        { key: 'line1', label: 'Address Line 1', widthClass: 'w-[295px] md:w-[600px] xl:w-[573px]', labelWidthClass: 'w-[98px]' },
        { key: 'line2', label: 'Address Line 2', widthClass: 'w-[295px] md:w-[600px] xl:w-[573px]', optional: true },
        { key: 'city', label: 'City', widthClass: 'w-[141.5px] md:w-[314px] xl:w-[280.5px]', labelWidthClass: 'w-[26px]' },
        { key: 'postcode', label: 'Postal Code', widthClass: 'w-[141.5px] md:w-[314px] xl:w-[280.5px]', labelWidthClass: 'w-[79px]' }
    ]
};

